import { api } from '../axios';
import Authentication from './Authentication';

export const JOURNEY_ENDPOINT = '/journey';

import Mongo from './Mongo';
import { EveResponse, UserJourney } from '../../types';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

class Journey extends Mongo {
  public async fetch({ where = {}, page = 1, max = 10 }) {
    try {
      const loginData = Authentication.loggedUser();
      if (!loginData) return;
      where = {
        user_email: loginData.user.email,
        area: loginData.area.name,
        ...where,
      };
      const flattenQuery = this.flattenMongoQuery({ query: where }) as unknown;

      const axiosConfig: AxiosRequestConfig = {
        params: {
          where: flattenQuery,
          page,
          max,
        },
      };

      const response: AxiosResponse<EveResponse<UserJourney[]>> = await api.get(
        JOURNEY_ENDPOINT,
        axiosConfig
      );
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  public async getById(id: string) {
    try {
      const loginData = Authentication.loggedUser();
      if (!loginData) return;

      const response = await api.get<UserJourney>(`${JOURNEY_ENDPOINT}/${id}`);

      return response;
    } catch (error) {
      console.error(error);
    }
  }
  public async create(data?: Partial<UserJourney>) {
    try {
      const loginData = Authentication.loggedUser();
      if (!loginData) return;
      const payload = {
        user_email: loginData.user.email,
        area: loginData.area.name,
        ...data,
      };
      const response = await api.post<UserJourney>(JOURNEY_ENDPOINT, payload);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  public async update(id: string, data: Partial<UserJourney>) {
    try {
      const response = await api.patch<UserJourney>(
        `${JOURNEY_ENDPOINT}/${id}`,
        data
      );
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new Journey();
